import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { CustomDropdown, createAssigneeOptions, getAssigneeIcon, outOfOfficeForAssignee } from '@medprompt/shared';
import {
  WorkflowActionEnum,
  WORKFLOW_ACTION_TYPE_OPTIONS,
  RISK_CATEGORY_OPTIONS,
  createDefaultAction,
  getWorkflowActionParamKey,
} from '../WorkflowActionEnum';
import '../WorkflowView.css';

const WorkflowActionCard = ({ action, index, onChange, onRemove, activeUsers, teams }) => {
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const [paramDropdownOpen, setParamDropdownOpen] = useState(false);

  const handleTypeChange = (option) => {
    onChange(createDefaultAction(option.value));
    setTypeDropdownOpen(false);
  };

  const handleParamChange = (value) => {
    onChange({ ...action, [getWorkflowActionParamKey(action.type)]: value });
    setParamDropdownOpen(false);
  };

  const renderParameterInput = () => {
    switch (action.type) {
      case WorkflowActionEnum.ASSIGN_DOCUMENT.value:
        const assigneeOptions = createAssigneeOptions(activeUsers, teams);
        const selectedAssignee = assigneeOptions.find(opt => opt.userId === action.assigneeId) || assigneeOptions[0];
        const selectedIcon = getAssigneeIcon(action.assigneeId, activeUsers, teams);
        return (
          <CustomDropdown
            searchable
            searchPlaceholder="Search assignees..."
            label="User/Team"
            selected={selectedAssignee.display}
            selectedIcon={selectedIcon}
            selectedOutOfOffice={outOfOfficeForAssignee(action.assigneeId, activeUsers)}
            options={assigneeOptions}
            isOpen={paramDropdownOpen}
            toggleDropdown={() => setParamDropdownOpen(!paramDropdownOpen)}
            onSelect={(option) => handleParamChange(option.userId)}
            keyExtractor={(option) => `assignee-${option.id}`}
          />
        );

      case WorkflowActionEnum.UPDATE_RISK_CATEGORY.value:
        const selectedRisk = RISK_CATEGORY_OPTIONS.find(opt => opt.value === action.riskCategory) || RISK_CATEGORY_OPTIONS[0];
        return (
          <CustomDropdown
            label="Urgency"
            selected={selectedRisk.name}
            options={RISK_CATEGORY_OPTIONS}
            isOpen={paramDropdownOpen}
            toggleDropdown={() => setParamDropdownOpen(!paramDropdownOpen)}
            onSelect={(option) => handleParamChange(option.value)}
            keyExtractor={(option) => `risk-${option.value}`}
          />
        );

      case WorkflowActionEnum.ADD_COMMENT.value:
        return (
          <div className="comm-content-section">
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
              Comment:
            </label>
            <textarea
              className="workflow-comment-textarea"
              value={action.comment || ''}
              onChange={(e) => onChange({ ...action, comment: e.target.value })}
              placeholder="Enter comment text..."
              rows={4}
            />
          </div>
        );

      default:
        return null;
    }
  };

  const selectedType = WORKFLOW_ACTION_TYPE_OPTIONS.find(opt => opt.value === action.type) || WORKFLOW_ACTION_TYPE_OPTIONS[0];

  return (
    <div className="workflow-card">
      <div className="workflow-card-header">
        <CustomDropdown
          label="Action Type"
          selected={selectedType.name}
          options={WORKFLOW_ACTION_TYPE_OPTIONS}
          isOpen={typeDropdownOpen}
          toggleDropdown={() => setTypeDropdownOpen(!typeDropdownOpen)}
          onSelect={handleTypeChange}
          keyExtractor={(option) => `type-${option.value}`}
          width="300px"
        />
        <button
          className="workflow-card-remove"
          onClick={() => onRemove(index)}
          title="Remove action"
          type="button"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
      <div className="workflow-card-body">
        {renderParameterInput()}
      </div>
    </div>
  );
};

export default WorkflowActionCard;
